<template>
  <div class="new-visit-container">
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        class="center-spinner"
        v-if="loading"
      >
        <spinner
          size="100"
          :line-size="15"
          line-fg-color="#0099da"
          message="Ładowanie..."
          text-fg-color="white"
        />
      </div>
    </transition>
    <transition
      name="slide-delayed"
      mode="out-in"
    >
      <div
        v-if="!loading"
        class="pick-visit-container"
      >
        <p v-if="!isMobile && !isXSMobile">
          Wybierz preferowany dzień wizyty oraz jedną z proponowanych godzin oddania auta. Termin odbioru auta zostanie ustalony indywidualnie.
        </p>
        <div class="wrapper">
          <div class="datepicker-container">
            <div class="datepicker-wrapper">
              <div>
                <div class="input-wrapper">
                  <datepicker
                    @input="onInput($event)"
                    :language="pl"
                    :format="formatter"
                    :disabled-dates="disabledDates"
                    v-model="datepickerDate"
                  />
                  <div class="calendar-wrapper">
                    <svg class="icon" svg-inline="" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><g class="nc-icon-wrapper" fill="#111"><path d="M19.9 11.6a1.35 1.35 0 0 0 1.3-1.4v-4a1.3 1.3 0 0 0-2.6 0v4.1a1.26 1.26 0 0 0 1.22 1.3h.08zm8.7 0a1.35 1.35 0 0 0 1.3-1.4v-4a1.3 1.3 0 1 0-2.6 0v4.1a1.26 1.26 0 0 0 1.22 1.3h.08zm-17.3 0a1.35 1.35 0 0 0 1.3-1.4v-4a1.3 1.3 0 1 0-2.6 0v4.1a1.26 1.26 0 0 0 1.22 1.3h.08z"/><path d="M32 9.8v.5a3.3 3.3 0 1 1-6.6 0v-.5h-2v.5a3.3 3.3 0 1 1-6.6 0v-.5h-2v.5a3.3 3.3 0 0 1-6.6 0v-.5h-4v25.3h31.6V9.8H32zM15.1 31.2H9.3v-5.9h5.8v5.9zm0-7.9H9.3v-5.9h5.8v5.9zm7.8 7.9h-5.8v-5.9h5.8v5.9zm0-7.9h-5.8v-5.9h5.8v5.9zm7.7 7.9h-5.8v-5.9h5.8v5.9zm0-7.9h-5.8v-5.9h5.8v5.9z"/></g></svg>
                  </div>
                </div>
                <standard-button
                  class="first-available-button fluid"
                  @buttonClick="showFirstAvailable()"
                  :disabled="!firstAvailableDate"
                  text="Najbliższy termin u wybranego PS"
                />
              </div>
              <div
                v-if="!isMobile && !isXSMobile"
                class="visitpicker-key"
              >
                <ul class="key-list">
                  <li class="key-element">
                    <span class="key-indicator" />
                    <span class="key-text">
                      Termin dostępny u wybranego Partnera Serwisowego
                    </span>
                  </li>
                  <li class="key-element">
                    <span class="key-indicator" />
                    <span class="key-text">
                      Termin dostępny w okolicy wybranego Partnera Serwisowego
                    </span>
                  </li>
                  <li class="key-element">
                    <span class="key-indicator" />
                    <span class="key-text">
                      Wybrany termin
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="visitpicker-container">
            <div class="visitpicker">
              <div class="week-control">
                <a
                  href=""
                  @click.prevent="isToday(preferredDayjs) ? null : prevWeek()"
                  class="prev-date-link"
                  :class="{ 'disabled': isToday(preferredDayjs) }"
                >
                  <!-- eslint-disable-next-line -->
                  <svg svg-inline="" class="previous" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M23.2 9.1L13 19.4c-.2.2-.3.5-.3.6 0 .3.1.5.3.7l10.2 10.2c.4.4 1 .4 1.4 0l2.3-2.3c.4-.4.4-1 0-1.4L19.7 20l7.2-7.2c.4-.4.4-1 0-1.4l-2.3-2.3c-.4-.3-1-.3-1.4 0z" fill="#111"/></svg>
                </a>
              </div>
              <div class="visitpicker-content">
                <div
                  class="visitpicker-date"
                  v-for="(day, index) in selectedWeek"
                  :key="index"
                  :class="{
                    'preferred' : day.isSame(toDayjsFormat(preferredDate)) && !openedDays[day.format('YYYY-MM-DD')],
                    'weekend': day.format('ddd') === 'Sob' || day.format('ddd') === 'Ndz',
                    'disabled': availableDates !== null &&
                      availableDates[day.format('YYYY-MM-DD')] !== undefined &&
                      availableDates[day.format('YYYY-MM-DD')].isClosed &&
                      !availableDates[day.format('YYYY-MM-DD')].hours.length,
                  }"
                  :style="{
                    // eslint-disable-next-line
                    borderColor: day.isSame(toDayjsFormat(preferredDate)) && !openedDays[day.format('YYYY-MM-DD')] && isMobile ? buttonColor : 'transparent'
                  }"
                >
                  <div class="date-head">
                    <div>
                      {{ day.format('ddd') }}
                    </div>
                    <div>
                      {{ day.format('DD.MM.YYYY') }}
                    </div>
                  </div>
                  <template
                    v-if="availableDates !== null &&
                      availableDates[day.format('YYYY-MM-DD')] !== undefined &&
                      !availableDates[day.format('YYYY-MM-DD')].isClosed &&
                      (availableDates[day.format('YYYY-MM-DD')].hours.length || availableDates[day.format('YYYY-MM-DD')].partners.length)"
                  >
                    <standard-button
                      class="available-else-button"
                      text="Dostępne u innego Partnera"
                      @buttonClick="changePartnerModal(availableDates[day.format('YYYY-MM-DD')].partners)"
                      v-if="!availableDates[day.format('YYYY-MM-DD')].hours.length &&
                        availableDates[day.format('YYYY-MM-DD')].partners.length &&
                        !availableDates[day.format('YYYY-MM-DD')].isClosed"
                    />
                  </template>
                  <template
                    v-if="availableDates !== null &&
                      availableDates[day.format('YYYY-MM-DD')] !== undefined &&
                      availableDates[day.format('YYYY-MM-DD')].hours.length"
                  >
                    <standard-button
                      class="available-time-button"
                      class-type="primary"
                      :class="{
                        'active': isButtonActive(day, time),
                      }"
                      @buttonClick="selectVisitDate(day, time)"
                      v-for="(time, i) in uniqHours(availableDates[day.format('YYYY-MM-DD')].hours, day.format('YYYY-MM-DD'))"
                      :key="i"
                      :text="time"
                    />
                  </template>
                  <div
                    class="not-available-button"
                    v-if="!(availableDates !== null &&
                      availableDates[day.format('YYYY-MM-DD')] !== undefined &&
                      availableDates[day.format('YYYY-MM-DD')].hours.length) &&
                      !(availableDates[day.format('YYYY-MM-DD')] !== undefined &&
                        !availableDates[day.format('YYYY-MM-DD')].isClosed &&
                        (availableDates[day.format('YYYY-MM-DD')].hours.length ||
                        availableDates[day.format('YYYY-MM-DD')].partners.length))"
                  />
                </div>
              </div>
              <div class="week-control">
                <a
                  href=""
                  @click.prevent="nextWeek()"
                  class="next-date-link"
                >
                  <svg svg-inline="" class="next" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M16.8 30.9L27 20.6c.2-.2.3-.5.3-.6 0-.3-.1-.5-.3-.6L16.8 9.1c-.4-.4-1-.4-1.4 0l-2.3 2.3c-.4.4-.4 1 0 1.4l7.2 7.1-7.2 7.2c-.4.4-.4 1 0 1.4l2.3 2.3c.4.4 1 .4 1.4.1z" fill="#111"/></svg>
                </a>
              </div>
            </div>
          </div>
          <div
            v-if="isMobile || isXSMobile"
            class="visitpicker-key"
          >
            <ul class="key-list">
              <li class="key-element">
                <span class="key-indicator" />
                <span class="key-text">
                  Termin dostępny u wybranego PS
                </span>
              </li>
              <li class="key-element">
                <span class="key-indicator" />
                <span class="key-text">
                  Termin dostępny w okolicy wybranego PS
                </span>
              </li>
              <li class="key-element">
                <span class="key-indicator" />
                <span class="key-text">
                  Wybrany termin
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import StandardButton from '~/StandardButton';
import dayjs from 'dayjs';
import { pl } from 'vuejs-datepicker/dist/locale';
import { mapActions, mapGetters } from 'vuex';
import dayjsPL from '@/helpers/dayjs-pl';
import Spinner from 'vue-simple-spinner';
import uniq from 'lodash/uniq';

dayjs.locale(dayjsPL);

export default {
  components: {
    Datepicker,
    StandardButton,
    Spinner,
  },
  data() {
    const now = dayjs().toDate();
    const yesterday = dayjs().subtract(1, 'day').toDate();
    return {
      preferredDate: now,
      pl,
      disabledDates: {
        to: yesterday,
      },
      openedDays: {},
      loading: true,
      datepickerDate: now,
    };
  },
  computed: {
    ...mapGetters({
      selectedPartner: 'visit/selectedPartner',
      buttonColor: 'brand/getThirdColor',
      availableDates: 'visit/availableDates',
      primaryColor: 'brand/getPrimaryColor',
      secondaryColor: 'brand/getSecondaryColor',
      servicePrice: 'visit/price',
      selectedVisitDate: 'visit/selectedVisitDate',
      registeredVisit: 'visit/registeredVisit',
    }),
    selectedWeek() {
      const preferredDate = dayjs(this.preferredDate);
      const preferredMonday = preferredDate.startOf('week').subtract(-1, 'day');
      const preferredWeek = [];

      if (this.isMobile || this.isTablet) {
        preferredWeek.push(preferredDate.subtract(1, 'day'));
        preferredWeek.push(preferredDate);
        preferredWeek.push(preferredDate.add(1, 'day'));
      } else if (this.isXSMobile) {
        preferredWeek.push(preferredDate);
      } else if (this.isLaptop) {
        for (let i = 0; i < 5; i++) {
          preferredWeek.push(preferredDate.add(i - 2, 'day'));
        }
      } else {
        for (let i = 0; i < 7; i++) {
          preferredWeek.push(preferredMonday.add(i, 'day'));
        }
      }

      return preferredWeek;
    },
    busyWeek() {
      const week = this.selectedWeek.map(day => day.format('YYYY-MM-DD'));
      // eslint-disable-next-line
      const isBusy = week.some((day) => {
        if (this.availableDates !== null && this.availableDates[day] !== undefined) {
          return this.availableDates[day].hours.length > 0;
        }
      });

      return isBusy;
    },
    isMobile() {
      return this.$mq === 'mobile';
    },
    isXSMobile() {
      return this.$mq === 'xs';
    },
    isTablet() {
      return this.$mq === 'tablet';
    },
    isLaptop() {
      return this.$mq === 'laptop';
    },
    price() {
      if (this.servicePrice) {
        return `${this.servicePrice.toFixed(2).replace('.', ',')} PLN*`;
      }
      return 0;
    },
    preferredDayjs() {
      return dayjs(this.preferredDate);
    },
    firstFreeSlot() {
      return this.availableDates.find(date => date.hours.length);
    },
    carID() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      }
      return this.chosenCar.id;
    },
    firstAvailableDate() {
      if (this.availableDates) {
        return Object.keys(this.availableDates).find(date => this.availableDates[date].hours.length > 0);
      }
      return null;
    },
  },
  methods: {
    ...mapActions({
      fetchDatesAndPrices: 'visit/fetchAvailableDates',
      setModalContent: 'modal/setContent',
      setModalMode: 'modal/setModalMode',
      setModalStep: 'modal/setModalStep',
      toggleModal: 'modal/openModal',
      setSelectedVisitDate: 'visit/setSelectedVisitDate',
      setSelectedPartner: 'visit/setSelectedPartner',
      setSelectedServices: 'visit/setSelectedServices',
      setSelectedVin: 'visit/setSelectedVin',
      setSelectedLicensePlate: 'visit/setSelectedLicensePlate',
      setSelectedCarModelID: 'visit/setSelectedCarModelID',
      setRegisteredVisit: 'visit/setRegisteredVisit',
      loadSavedData: 'visit/loadSavedData',
    }),
    uniqHours(hours, day) {
      const sortedHours = hours.map((current) => {
        const currentUnix = dayjs(`${day} ${current}`, 'YYYY-MM-DD HH:mm').unix();
        return {
          hour: current,
          unix: currentUnix,
        };
      })
        .sort((current, prev) => current.unix - prev.unix)
        .map(item => item.hour);

      return uniq(sortedHours);
    },
    onInput(value) {
      this.preferredDate = value;
    },
    isButtonActive(date, hours) {
      const formattedDay = date.format('YYYY-MM-DD');

      if (this.selectedVisitDate) {
        const { day, time } = this.selectedVisitDate;

        return day === formattedDay && time === hours;
      }
      return false;
    },
    formatter(date) {
      return dayjs(date).format('DD/MM/YYYY');
    },
    nextWeek() {
      const setPreferredDate = (days) => {
        this.preferredDate = dayjs(this.preferredDate).add(days, 'day').toDate();
      };
      if (this.isMobile || this.isXSMobile || this.isTablet) {
        setPreferredDate(1);
      } else if (this.isLaptop) {
        setPreferredDate(5);
      } else {
        setPreferredDate(7);
      }
    },
    prevWeek() {
      const setPreferredDate = (days) => {
        if (dayjs(this.preferredDate).subtract(days, 'day').isBefore(dayjs(), 'day')) {
          this.preferredDate = dayjs().toDate();
        } else {
          this.preferredDate = dayjs(this.preferredDate).subtract(days, 'day').toDate();
        }
      };

      if (this.isMobile || this.isXSMobile || this.isTablet) {
        setPreferredDate(1);
      } else if (this.isLaptop) {
        setPreferredDate(5);
      } else {
        setPreferredDate(7);
      }
    },
    setOpenedDays() {
      this.selectedWeek.forEach((day) => {
        this.$set(this.openedDays, day.format('YYYY-MM-DD'), false);
      });
    },
    isToday(time) {
      return time.format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD');
    },
    toggleAvailableTimes(day) {
      const date = day.format('YYYY-MM-DD');

      Object.keys(this.openedDays).forEach((key) => {
        if (date === key) {
          this.openedDays[date] = !this.openedDays[date];
        } else {
          this.openedDays[key] = false;
        }
      });
    },
    selectVisitDate(day, time) {
      const formattedDay = day.format('YYYY-MM-DD');

      this.setSelectedVisitDate({ day: formattedDay, time });
    },
    toDayjsFormat(date) {
      return dayjs(date);
    },
    changePartnerModal(partners) {
      Object.keys(this.openedDays).forEach((key) => {
        if (this.openedDays[key]) {
          this.openedDays[key] = false;
        }
      });

      this.setModalContent({
        classes: 'pick-different-partner',
        subtitle: 'Wybierz innego Partnera Serwisowego',
        partners,
      });
      this.setModalStep('change_partner');
      this.toggleModal();
    },
    showFirstAvailable() {
      this.preferredDate = this.firstAvailableDate ? new Date(this.firstAvailableDate) : new Date();
    },
  },
  watch: {
    preferredDate() {
      this.setOpenedDays();
    },
  },
  mounted() {
    this.loadSavedData()
      .then(() => {
        const registeredID = this.registeredVisit ? this.registeredVisit.id : null;

        this.fetchDatesAndPrices({ partnerID: parseInt(this.selectedPartner.id, 10), visitID: registeredID })
          .then(() => {
            setTimeout(() => {
              this.loading = false;

              if (this.selectedVisitDate) {
                const parsedDay = dayjs(this.selectedVisitDate.day);
                this.selectVisitDate(parsedDay, this.selectedVisitDate.time);
              }
            }, 400);
          });
      });

    this.setOpenedDays();
  },
};
</script>
